export const pageURIs = {
    "home": "home",
    "search": "answer",
    "spotiq": "insights",
    "liveboard": "pinboard"
}

export const bestPracticesDocLinks = {
    "": "/help/Content/MDAE/Analytics_Audit-Performance/Audit-Insights/Audit-Insights-AI-Assist.htm",
    "?isforro=true": "/help/Content/MDAE/Analytics_Denials-Risk/Denial-Risks/Denial-Risks-AI-Assist.htm",
    "?isforea=true": "/help/Content/MDAE/Analytics_Audit-Performance/Payer-Audit-Insights/PA-AI-Assist.htm",
    "?isforpu=true": "/help/Content/MDAE/Analytics_Billing-Risks/Procedure-Utilization/Procedure-Utilization-AI-Assist.htm"
}